import React from 'react';

function PatientEngagementNav({ tabs, activeTab, onTabChange, counts = {} }) {
    return (
        <div className="patient-engagement-segment" role="tablist" aria-label="Patient engagement sections">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    type="button"
                    role="tab"
                    aria-selected={activeTab === tab.id}
                    className={`patient-engagement-segment__item ${activeTab === tab.id ? 'is-active' : ''}`}
                    onClick={() => onTabChange(tab.id)}
                >
                    <i className={`bi ${tab.icon} me-1`} />
                    {tab.label}
                    {counts[tab.id] != null && (
                        <span className="patient-engagement-segment__count">{counts[tab.id]}</span>
                    )}
                </button>
            ))}
        </div>
    );
}

export default PatientEngagementNav;
